import { render, staticRenderFns } from "./CustomSearchList.vue?vue&type=template&id=0789aef9&"
import script from "./CustomSearchList.vue?vue&type=script&lang=js&"
export * from "./CustomSearchList.vue?vue&type=script&lang=js&"
import style0 from "./CustomSearchList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomSearchList.vue"
export default component.exports